var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#725CF8","d":"M13.4343,0.156968 L12.5576,1.03353 C12.3453,1.24581 12.3488,1.5911 12.5653,1.79905 L16.1711,5.26125 L0.76945,5.26125 C0.473415,5.26125 0.233398,5.50122 0.233398,5.7972 L0.233398,7.04777 C0.233398,7.34375 0.473415,7.58373 0.76945,7.58373 L16.1711,7.58373 L12.5654,11.0459 C12.3488,11.2539 12.3453,11.5992 12.5577,11.8114 L13.4344,12.688 C13.6437,12.8973 13.9831,12.8973 14.1925,12.688 L20.0801,6.80145 C20.2894,6.59216 20.2894,6.25281 20.0801,6.04347 L14.1924,0.156968 C13.9831,-0.0523228 13.6437,-0.0523228 13.4343,0.156968 Z","transform":"matrix(-1 0 0 1 21 0)"}));
}

ArrowLeftInline.defaultProps = {"width":"21","height":"13","viewBox":"0 0 21 13"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
